var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileEsims(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1416_9860)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#34C659"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1416_9860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0807 9.98413H28.8911C31.2195 9.98413 33.0121 11.7577 33.0121 13.8317V26.1685C33.0121 28.2424 31.2195 30.016 28.8911 30.016H11.0807C8.75228 30.016 6.95966 28.2424 6.95966 26.1685V13.8317C6.95966 11.7577 8.75228 9.98413 11.0807 9.98413Z",
    fill: "white",
    stroke: "#34C659",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0621 24.3301H6.95966L6.95966 15.6697L12.0621 15.6697C13.7994 15.6697 14.7932 16.7505 14.7932 17.626L14.7932 22.3737C14.7932 23.2493 13.7994 24.3301 12.0621 24.3301Z",
    stroke: "#34C659",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0484 15.6699H33.3317V24.3303H28.0484C27.1895 24.3303 26.4481 24.0612 25.9421 23.6718C25.4371 23.2832 25.2068 22.8156 25.2068 22.374V17.6263C25.2068 17.1846 25.4371 16.7171 25.9421 16.3285C26.4481 15.9391 27.1895 15.6699 28.0484 15.6699Z",
    stroke: "#34C659",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2514 10.3245V15.4054C20.2514 16.51 19.356 17.4054 18.2514 17.4054H14.6115M14.6115 23.3323H18.2514C19.356 23.3323 20.2514 24.2277 20.2514 25.3323V29.6754",
    stroke: "#34C659",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6364 23.3333L25.5174 23.3333",
    stroke: "#34C659",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50745 20.1982L14.9079 20.1982",
    stroke: "#34C659",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0741 20.1982H32.5051",
    stroke: "#34C659",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1416_9860"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1416_9860"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 20,
    fill: "white",
    transform: "translate(7 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileEsims);
export default __webpack_public_path__ + "static/media/profile-esims.e9324ae5c7c24c1f6e7bfa15920a7b4b.svg";
export { ForwardRef as ReactComponent };